import { ActionIcon } from '@cowbell/ui/core';
import {
  ComponentPropsWithoutRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { CheckIcon, CopyIcon } from '../../ShellDrawer/icons';

export function AssistantCodeBlock({
  children,
  ...rest
}: Readonly<ComponentPropsWithoutRef<'pre'>>) {
  const [copied, setCopied] = useState(false);
  const preRef = useRef<HTMLPreElement>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    []
  );

  const handleCopy = useCallback(() => {
    const text = preRef.current?.textContent ?? '';
    navigator.clipboard
      .writeText(text)
      .then(() => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setCopied(true);
        timerRef.current = setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => undefined);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <pre ref={preRef} {...rest}>
        {children}
      </pre>
      <ActionIcon
        size="sm"
        variant="subtle"
        color="gray"
        style={{ position: 'absolute', top: 4, right: 4 }}
        onClick={handleCopy}
        aria-label={copied ? 'Copied' : 'Copy code'}
      >
        {copied ? <CheckIcon size={12} /> : <CopyIcon size={12} />}
      </ActionIcon>
    </div>
  );
}
